import React from "react";
import { Button, ButtonProps } from "@chakra-ui/react";
import { haptic } from "@/lib/haptic";
import "../../Animations.css";

export interface WhiteActivityButtonProps extends ButtonProps {
  children: React.ReactNode;
  leftIcon?: React.ReactElement;
  rightIcon?: React.ReactElement;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const WhiteActivityButton: React.FC<WhiteActivityButtonProps> = ({
  children,
  leftIcon,
  rightIcon,
  onClick,
  ...props
}) => {
  const [isAnimating, setIsAnimating] = React.useState(false);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    haptic.soft();
    setIsAnimating(true);
    setTimeout(() => {
      setIsAnimating(false);
      if (onClick) {
        onClick(e);
      }
    }, 300);
  };

  const baseStyles = {
    width: "100%",
    height: "calc(var(--button-height) + 10px)",
    borderRadius: "xl",
    shadow: "md",
    fontSize: "var(--base-font-size)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 1,
    border: "var(--color-grey-lightest)",
    bg: "white",
    color: "var(--color-blue)",
    _hover: {},
    _active: {},
    _focus: {},
  };

  return (
    <Button
      leftIcon={leftIcon}
      rightIcon={rightIcon}
      onClick={handleClick}
      className={`${isAnimating ? "press-animation" : ""}`}
      {...baseStyles}
      {...props}
    >
      {children}
    </Button>
  );
};

export default WhiteActivityButton; 